import React from 'react'
import { CButton, CCard, CCardBody, CCol, CRow } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import * as icons from '@coreui/icons'
import { cilBolt } from '@coreui/icons'
import { useNavigate } from 'react-router-dom'
import { STEP_ICON } from './stepStatus'

const NextStepCard = ({ nextStep, onActivateGame }) => {
  const navigate = useNavigate()

  if (!nextStep) {
    return (
      <CCard className="mb-4 border-success">
        <CCardBody>
          <CRow className="align-items-center">
            <CCol>
              <strong>All essential steps are complete.</strong> Your game is ready to activate.
            </CCol>
            <CCol xs="auto">
              <CButton color="success" onClick={onActivateGame}>
                <CIcon icon={cilBolt} className="me-2" />
                Activate Game
              </CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    )
  }

  const scrollToLaunchEssentials = () => {
    document.getElementById('launch-essentials')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <CCard className="mb-4 border-warning">
      <CCardBody>
        <CRow className="align-items-center">
          <CCol xs="auto">
            <CIcon icon={icons[STEP_ICON[nextStep.key]]} size="xl" className="text-warning" />
          </CCol>
          <CCol>
            <div className="text-medium-emphasis">Next Step</div>
            <div className="fw-bold mb-1">{nextStep.label}</div>
            {nextStep.description && <div className="mb-2">{nextStep.description}</div>}
            <CButton color="primary" className="me-2" onClick={() => navigate(nextStep.route)}>
              Continue to {nextStep.label}
            </CButton>
            <CButton color="secondary" variant="outline" onClick={scrollToLaunchEssentials}>
              View All Steps
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  )
}

export default NextStepCard
